import React from 'react';
import {
  Select,
  SelectOptionWithCountryFlag,
  SelectSingleValueWithCountryFlag,
} from '@dealroadshow/uikit-select';
import { ILandingCurrency } from './ILandingCurrency';

interface IProps {
  name?: string,
  value: ILandingCurrency,
  onChange: (selectedCurrency: ILandingCurrency) => void,
  onBlur?: () => void,
  label?: string,
  isDisabled: boolean,
  isNarrow?: boolean,
  options: ILandingCurrency[],
}

const CurrenciesSelect = ({
  name = 'currency',
  value,
  isNarrow = true,
  ...otherProps
}: IProps) => (
  // @ts-ignore // TODO: fix strictFunctionTypes types
  <Select<ILandingCurrency>
    name={ name }
    isNarrow={ isNarrow }
    isSupportHighlighting={ false }
    // @ts-ignore
    isSearchable={ false }
    value={ value }
    components={ {
      Option: SelectOptionWithCountryFlag,
      SingleValue: SelectSingleValueWithCountryFlag,
    } }
    dataTest="currency"
    { ...otherProps }
  />
);

export default CurrenciesSelect;
